import { createRootRoute, createRoute, createRouter, Outlet } from "@tanstack/react-router";
import { LobbyPage } from "./screens/LobbyPage.tsx";
import { RoomPage } from "./screens/RoomPage.tsx";
import { DemoPage } from "./screens/DemoPage.tsx";
import { DeckBuilderPage } from "./screens/DeckBuilderPage.tsx";
import { CardShowcasePage } from "./screens/CardShowcasePage.tsx";

const rootRoute = createRootRoute({
  component: () => <Outlet />,
  notFoundComponent: () => <main className="center-page"><div className="empty-state"><span>404</span><h1>Out of bounds</h1><a href="/">Return to the clubhouse</a></div></main>
});

const indexRoute = createRoute({ getParentRoute: () => rootRoute, path: "/", component: LobbyPage });
const roomRoute = createRoute({ getParentRoute: () => rootRoute, path: "/rooms/$roomId", component: RoomPage });
const demoRoute = createRoute({ getParentRoute: () => rootRoute, path: "/demo", component: DemoPage });
const deckBuilderRoute = createRoute({ getParentRoute: () => rootRoute, path: "/deck-builder", component: DeckBuilderPage });
const cardsRoute = createRoute({ getParentRoute: () => rootRoute, path: "/cards", component: CardShowcasePage });
const routeTree = rootRoute.addChildren([indexRoute, roomRoute, demoRoute, deckBuilderRoute, cardsRoute]);

export const router = createRouter({ routeTree, defaultPreload: "intent" });

declare module "@tanstack/react-router" {
  interface Register { router: typeof router }
}
